import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedContent from './components/FeaturedContent';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '久久综合',
  url: 'https://jiujiuzonghe.com',
  description: '久久综合是专注多元内容聚合的一站式平台，汇集影视、音乐、图文、资讯等丰富资源。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://jiujiuzonghe.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '久久综合',
  url: 'https://jiujiuzonghe.com',
  description: '久久综合 - 海量资源一站式聚合平台',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'support@jiujiuzonghe.com',
    contactType: 'customer service',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '久久综合平台提供哪些类型的内容资源？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '久久综合平台汇集了影视资源、音乐天地、图文精选、资讯快报、学习资料和软件工具等六大类内容资源，覆盖您日常生活和工作中的全方位需求。',
      },
    },
    {
      '@type': 'Question',
      name: '久久综合的内容多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '久久综合平台的内容保持每日更新，编辑团队全天候关注各领域最新动态，确保您第一时间获取新鲜、有价值的内容。',
      },
    },
    {
      '@type': 'Question',
      name: '久久综合平台是否免费使用？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，久久综合平台对所有用户完全免费开放，不收取任何费用。您可以免费浏览所有内容、使用搜索功能。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <SEOHead
        title="久久综合 - 海量资源一站式聚合平台"
        description="久久综合是专注多元内容聚合的一站式平台，汇集影视、音乐、图文、资讯等丰富资源。内容持续更新，分类清晰，搜索便捷。"
        keywords="久久综合,久久综合资源,久久综合导航,久久综合平台,久久综合内容聚合"
        canonicalUrl="https://jiujiuzonghe.com/"
      />

      <main>
        <article>
          <HeroSection />
        </article>
        <FeaturedContent />
        <CategoryNav />
        <LatestArticles />
        <FAQSection />
      </main>
    </>
  );
}